import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'quantity-input',
  templateUrl: './quantity-input.component.html',
  styleUrls: ['./quantity-input.component.css']
})
export class QuantityInputComponent {
  @ViewChild('quantityInput') quantityInputField!: ElementRef;
  @Input() public value: number | null | undefined = undefined;
  @Output() onValueChange = new EventEmitter<number | null>();
  @Output() onNonNumericInput = new EventEmitter<string>();
  get fieldValue(): number | null { return this.value || null; }

  @Input() public buttonBGColor?: string;
  @Input() public buttonFGColor?: string;
  @Input() public maxlength?: number;

  constructor(
    private snackBar: MatSnackBar
  ) { }

  add(amount: number) {
    this.value = (this.value || 0) + amount;
    if (this.value <= 0) this.value = null;
    this.onValueChange.emit(this.value);
  }

  public focus() {
    let element = this.quantityInputField.nativeElement;
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    element.focus();
    element.select();
  }

  // #region Scanner Input handling
  private _scanInputBuffer: string = '';
  private _scanKeyTimer?: number;
  onKeyPress(event: KeyboardEvent) {
    if (event.key == 'Enter') {
      event.preventDefault();
      this.processScanInput();
    }
    else {
      window.clearTimeout(this._scanKeyTimer);
      this._scanInputBuffer += event.key;
      event.preventDefault();
      this._scanKeyTimer = window.setTimeout(() => {
        this.quantityInputField.nativeElement.value += this._scanInputBuffer;
        this._scanInputBuffer = '';
      }, 2000);
    }
  }

  private processScanInput() {
    window.clearTimeout(this._scanKeyTimer);
    if (this._scanInputBuffer == '') return;

    // all numerals? -- quantity input
    if (/^\d+$/.test(this._scanInputBuffer)) {
      this.quantityInputField.nativeElement.value = this._scanInputBuffer;
      this._scanInputBuffer = '';
      this.emitValueChange(this.quantityInputField.nativeElement)
    }

    else {
      // Inventory ID / QR URL
      this.onNonNumericInput.emit(this._scanInputBuffer);
      this._scanInputBuffer = '';
    }
  }

  // keypress fires for non-control keys and can be 'prevented'
  // (the event does not fire for keys like backspace)
  // onKeyPress(event: KeyboardEvent) {
  //   this.monitorScannerInput(event.key);

  //   const numerals = /[0-9]/;
  //   if (this._scanKeyTimer || !numerals.test(event.key)) {
  //     // invalid input -- prevent it
  //     event.preventDefault();
  //     return;
  //   }

  //   // timeout to allow underlying input field to receive key
  //   setTimeout(() => this.emitValueChange(event.target), 100);
  // }

  // onKeyDown(event: KeyboardEvent) {
  //   // timeout to allow underlying input field to receive key
  //   setTimeout(() => this.emitValueChange(event.target), 100);
  // }

  emitValueChange(target: any) {
    if (target === null) return;
    this.value = parseInt((<any>target!).value);
    this.onValueChange.emit(this.value || null);
  }

  // handle situation of user scanning an HTTP:// QR into the quantity field
  // private _scanInput: string = '';
  // private _scanKeyTimer?: number;
  // private _barcodeScannerFeedbackSnackbar?: MatSnackBarRef<BarcodeScannerFeedback>;
  // monitorScannerInput(key: string) {
  //   window.clearTimeout(this._scanKeyTimer);
  //   if (key == 'Enter') {
  //     this.emitScanInput();
  //   } else {
  //     this._scanInput += key;
  //     if (!this._barcodeScannerFeedbackSnackbar) {
  //       this._barcodeScannerFeedbackSnackbar = this.snackBar.openFromComponent(BarcodeScannerFeedback, {
  //         panelClass: 'screen-top-snackbar'
  //       });
  //     }
  //     this._barcodeScannerFeedbackSnackbar.instance.data = this._scanInput;
  //     this._scanKeyTimer = window.setTimeout(() => this.emitScanInput(), 200);
  //   }
  // }

  // private emitScanInput() {
  //   // raise the event notifying of the 'invalid' / QR scan
  //   if (this._scanInput) this.onNonNumericInput.emit(this._scanInput);
  //   this._scanInput = '';
  //   this._barcodeScannerFeedbackSnackbar?.dismiss();
  //   this._barcodeScannerFeedbackSnackbar = undefined;
  // }

  // #endregion
}

@Component({
  selector: 'barcode-feedback-snackbar',
  template: '{{data}}'
})
export class BarcodeScannerFeedback {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) { }
}